import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, FormGroup } from "reactstrap";

import { TextField, Select, MenuItem, InputLabel, FormControl, OutlinedInput, Checkbox, ListItemText, Modal, Button } from "@mui/material";
import { makeStyles } from '@mui/styles';

import "react-phone-number-input/style.css";
import PhoneInput, { isPossiblePhoneNumber  } from 'react-phone-number-input';

import { countryList } from "../../../utilities/countries";
import { extractCountryCallingCode, extractPhoneNumber } from "../../../utilities/extractPhoneNumber";

import {
  putOrgUser,
  clearAllOrgUserMessages,
  getOrgAccounts
} from "../../../store/actions";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

// const resourceGroups = [
//   "Engineering",
//   "Finance",
//   "H.R",
//   "Unassigned"
// ];

// const roles = [
//   "Administrator",
//   "PowerUser",
//   "StandardUser"
// ];


const EditUserModal = (props) => {
  console.log("EditUserModal props: " , props);
  const classes = useStyles();
  const { orgCode } = props;
  const [formData, setFormData] = useState({ ...props.editUserData});
  const [showPassword, setShowPassword] = useState(false);
  const [phoneError, setPhoneError] = useState(false);

  console.log("~~~~~~~~~~~~~EditUserModal  formData : " , formData);
  console.log("~~~~~~~~~~~~~Available resource groups:", props.resourceGroups);
  console.log("~~~~~~~~~~~~~Currently selected resource groups:", formData.resourceGroups);

  const handleModalClose = () => {
    props.handleModalClose();
    props.setOpen(false);    
  };

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData({...formData, [name]: value});
  }

  const handleResourceGroupChange = (e) => {
    const {
      target: { value },
    } = e;

    setFormData({
      ...formData, 
      resourceGroups: typeof value === "string" ? value.split(',') : value
    });
  }

  const handleRoleChange = (e) => {
    const {
      target: { value },
    } = e;

    setFormData({
      ...formData, 
      roles: [value]
    });
  }

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const invalidEmailErrorMessage = (email) => {
    if(email.length === 0) {
      return "Email is required";
    } else if(!isValidEmail(email)) {
      return "Email is not valid";
    } else {
      return "";
    }
  }

  const isValidPassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]+$/;
    return passwordRegex.test(password);
  }

  const invalidPasswordErrorMessage = (password) => {
    if(password.length === 0) {
      return "Password is required";
    } else if(password.length<8 || password.length>16) {
      return "Password must be between 8 and 16 characters";
    }else if(!isValidPassword(password)) {
      return "Password must contain at least one capital letter and one special character";
    } else {
      return "";
    }
  }

  const isValidCountry = (country) => {
    return (!(country.length === 0) && !(country === "Select Country"))
  }

  const invalidCountryErrorMessage = (country) => {
    // console.log("Selected country is ."+country+".");
    if(country.length === 0) {
      return "Country is required";
    } else if(country === "Select Country") {
      return "Select correct country";
    } else {
      return "";
    }
  }

  const isValidResourceGroups = (resourceGroups) => {
    return !(resourceGroups.length === 0)
  }

  const invalidResourceGroupsErrorMessage = (resourceGroups) => {
    if(resourceGroups.length === 0) {
      return "Resource Groups is required";
    } else {
      return "";
    }
  }

  const isValidRoles = (roles) => {
    return !(roles.length === 0)
  }

  const invalidRolesErrorMessage = (roles) => {
    if(roles.length === 0) {
      return "Roles is required";
    } else {
      return "";
    }
  }  

  const handlePhoneChange = (value) => {
    let isInvalidResult;
    if (value===null || value === "" || value === undefined) {
      isInvalidResult = true;
      value="";
    } else {
      isInvalidResult = !isPossiblePhoneNumber(value);
    }
    if (isInvalidResult) {
      setFormData({...formData, phoneNumber: value });
      setPhoneError("Please enter a valid phone number");
    } else {
      setFormData({...formData, phoneNumber: value });
      setPhoneError("");
    }
  }

  const handlePhoneBlur = () => {
    let isInvalidResult;
    if (!formData.phoneNumber){
      isInvalidResult = true;
    } else {
      isInvalidResult = !isPossiblePhoneNumber(formData.phoneNumber);
    }
    if (isInvalidResult) {
      setPhoneError("Please enter a valid phone number");
    } else {
      setPhoneError("");
    }
  }

  const isValidForm = () => {
    const valid = formData.firstName.length !== 0 && 
                  formData.lastName.length !== 0 &&
                  isValidEmail(formData.email) &&
                  !phoneError &&
                  // formData.userName.length !== 0 &&
                  // isValidPassword(formData.password) && 
                  isValidCountry(formData.country) && 
                  isValidResourceGroups(formData.resourceGroups) ;
                  // &&
                  // isValidRoles(formData.roles);
    return valid;
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const updateUser = (event) => {
    formData.orgCode = orgCode;
    const countryCode = extractCountryCallingCode(formData.phoneNumber);
    const phoneNumber = extractPhoneNumber(formData.phoneNumber);
    
    // Filter resource groups to only include those that are available in the organization
    const filteredResourceGroups = formData.resourceGroups.filter(resourceGroup => 
      props.resourceGroups.includes(resourceGroup)
    );
    
    const userData = { 
      ...formData, 
      countryCode, 
      phoneNumber,
      resourceGroups: filteredResourceGroups
    }
    console.log("updateUser =", userData);
    console.log("Original selected resource groups:", formData.resourceGroups);
    console.log("Filtered resource groups being sent:", filteredResourceGroups);
    props.updateOrgUser(userData);
  }

  //Logic for success / failure response of API
  let editOrgUserMessage = props.editOrgUserMessage;
  let editOrgUserError = props.editOrgUserError;
  useEffect(() => {
    handlePhoneBlur();
    console.log("editOrgUserMessage = " + editOrgUserMessage);
    if (editOrgUserMessage || editOrgUserError) {
      console.log("Inside if, editOrgUserMessage = " + editOrgUserMessage);
      // setTimeout(() => {
      //   props.clearAllMessages();
      // }, 10000); // Hide all messages after 10 seconds
      if(editOrgUserMessage){
        // enqueueSnackbar(editOrgUserMessage, {variant: "success"});
        props.getOrgAccounts(orgCode);
        handleModalClose();
      }
      // if(editOrgUserError){
      //   enqueueSnackbar(editOrgUserError, {variant: "error"});
      // }      
    }
  }, [editOrgUserMessage, editOrgUserError, props]);  

  return (
    <div>
      {/* <SnackbarProvider /> */}
      <Modal
        className={classes.modal}
        open={props.isOpen}
        onClose={handleModalClose}
      >
        <div className={classes.paper}>
          <h3>Edit User for Organization</h3>
          {/* <p style={{width: "200px"}}>{JSON.stringify(formData)}</p> */}
          
          <Row>
            <Col md="6">
              <FormGroup>
                <TextField
                  name="firstName"
                  variant="outlined"
                  margin="dense"
                  size="small"
                  fullWidth
                  label="First name *"
                  value={formData.firstName}
                  placeholder="First name"
                  type="text"
                  id="firstName-input"
                  onChange={handleInputChange}
                  error={formData.firstName.length === 0 ? true : false}
                  helperText={
                    formData.firstName.length === 0
                      ? "First Name is required"
                      : ""
                  } 
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <TextField
                  name="lastName"
                  variant="outlined"
                  margin="dense"
                  size="small"
                  fullWidth
                  label="Last name *"
                  value={formData.lastName}
                  placeholder="Last name"
                  type="text"
                  id="lastName-input"
                  onChange={handleInputChange}
                  error={formData.lastName.length === 0 ? true : false}
                  helperText={
                    formData.lastName.length === 0
                      ? "Last Name is required"
                      : ""
                  } 
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {/* <Col md="6">
              <FormGroup>
              <TextField
                name="email"
                value={formData.email}
                placeholder="Email"
                type="text"
                variant="outlined"
                margin="dense"
                size="small"
                fullWidth
                label="Email *"
                id="email-input"
                onChange={handleInputChange}
                inputProps={{
                  type: "email",
                }}
                error={formData.email.length === 0 || !isValidEmail(formData.email)}
                helperText={ invalidEmailErrorMessage(formData.email)}
              />
              </FormGroup>
            </Col> */}
            <Col md="6" lg="6">
              <FormGroup>
                <PhoneInput
                  className={!phoneError? "phone-input": "phone-input invalid"}
                  id="phone-input"
                  name="phone"
                  aria-describedby="Phone Number"
                  placeholder="Phone Number"
                  value={formData.phoneNumber}
                  maxLength={16}
                  onChange={handlePhoneChange}
                  onBlur={handlePhoneBlur}
                  required
                />
                {phoneError ? (
                    <div className="phone-error" style={{fontSize: "80%", marginTop: "0.25rem", marginLeft: "1rem"}}>{phoneError}</div>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {/* <Col md="6">
              <FormGroup>
                <TextField
                  fullWidth
                  name="userName"
                  value={formData.userName}
                  placeholder="User Name"
                  type="text"
                  variant="outlined"
                  margin="dense"
                  size="small"
                  label="User Name *"
                  id="userName-input"
                  onChange={handleInputChange}
                  error={formData.userName.length === 0 ? true : false}
                  helperText={
                    formData.userName.length === 0
                      ? "User Name is required"
                      : ""
                  } 
                />
              </FormGroup>
            </Col> */}
            {/* <Col md="6">
              <FormGroup>
                <TextField
                  label="Password *"
                  variant="outlined"
                  name="password"
                  margin="dense"
                  size="small"
                  value={formData.password}
                  type={showPassword ? "text" : "password"}
                  id="password-input"
                  placeholder="Enter password"
                  fullWidth
                  onChange={handleInputChange}
                  error={formData.password.length === 0 || !isValidPassword(formData.password)}
                  helperText={invalidPasswordErrorMessage(formData.password)}                                          
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormGroup>
            </Col> */}
          </Row>
          <Row>
            <Col md="12">
              <FormGroup>
                <FormControl fullWidth>
                  <InputLabel id="country-select-label">Country</InputLabel>
                  <Select
                    // type="select"
                    label="Country"
                    variant="outlined"
                    margin="dense"
                    size="small"
                    name="country"
                    id="country-input"
                    labelId="country-select-label"
                    value={formData.country}
                    onChange={handleInputChange}
                    renderValue={(selected) => selected}
                    error={!isValidCountry(formData.country)}
                    helperText={ invalidCountryErrorMessage(formData.country) }
                  >
                    {countryList.map((country) => {
                      return (
                        <MenuItem key={country.code} value={country.name}>
                          {country.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {invalidCountryErrorMessage(formData.country) ? 
                    (
                      <div className="field-error" style={{fontSize: "80%", marginTop: "0.25rem", marginLeft: "1rem"}}>{invalidCountryErrorMessage(formData.country)}</div>
                    ) : 
                    null
                  }
                </FormControl>            
              </FormGroup>
            </Col>
            {/* <Col md="6">
              <FormGroup>
                <TextField
                  name="countryCode"
                  variant="outlined"
                  margin="dense"
                  size="small"
                  fullWidth
                  label="Country Code *"
                  value={formData.countryCode}
                  placeholder="Country Code"
                  type="text"
                  id="countryCode-input"
                  onChange={handleInputChange}
                  error={formData.countryCode.length === 0 ? true : false}
                  helperText={
                    formData.countryCode.length === 0
                      ? "Country Code is required"
                      : ""
                  } 
                />
              </FormGroup>
            </Col> */}
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <FormControl fullWidth>
                  <InputLabel id="rg-multiple-checkbox-label">Resource Groups</InputLabel>
                  <Select
                    labelId="rg-multiple-checkbox-label"
                    id="rg-multiple-checkbox-label"
                    multiple
                    variant="outlined"
                    margin="dense"
                    size="small"
                    value={formData.resourceGroups}
                    onChange={handleResourceGroupChange}
                    input={<OutlinedInput label="Resource Groups" />}
                    renderValue={(selected) => selected.join(', ')}
                    error={!isValidResourceGroups(formData.resourceGroups)}
                    helperText={invalidResourceGroupsErrorMessage(formData.resourceGroups)} 
                    // MenuProps={MenuProps}
                  >
                    {props.resourceGroups.map((resourceGroup) => (
                      <MenuItem key={resourceGroup} value={resourceGroup}>
                        <Checkbox checked={formData.resourceGroups.indexOf(resourceGroup) > -1} />
                        <ListItemText primary={resourceGroup} />
                      </MenuItem>
                    ))}
                  </Select>
                  {invalidResourceGroupsErrorMessage(formData.resourceGroups) ? 
                    (
                      <div className="field-error" style={{fontSize: "80%", marginTop: "0.25rem", marginLeft: "1rem"}}>{invalidResourceGroupsErrorMessage(formData.resourceGroups)}</div>
                    ) : 
                    null
                  }
                </FormControl>
              </FormGroup>
            </Col>
            {/* <Col md="6">
              <FormGroup>
                <FormControl fullWidth>
                  <InputLabel id="role-checkbox-label">Roles</InputLabel>
                  <Select
                    labelId="role-checkbox-label"
                    id="role-checkbox-label"
                    // multiple
                    variant="outlined"
                    margin="dense"
                    size="small"
                    value={formData.roles}
                    onChange={handleRoleChange}
                    input={<OutlinedInput label="Roles" />}
                    renderValue={(selected) => selected}
                    error={!isValidRoles(formData.roles)}
                    helperText={invalidRolesErrorMessage(formData.roles)}                   
                    // MenuProps={MenuProps}
                  >
                    {roles.map((role) => (
                      <MenuItem key={role} value={role}>
                        <Checkbox checked={formData.roles.indexOf(role) > -1} />
                        <ListItemText primary={role} />
                      </MenuItem>
                    ))}
                  </Select>
                  {invalidRolesErrorMessage(formData.roles) ? 
                    (
                      <div className="field-error" style={{fontSize: "80%", marginTop: "0.25rem", marginLeft: "1rem"}}>{invalidRolesErrorMessage(formData.roles)}</div>
                    ) : 
                    null
                  }
                </FormControl>              
              </FormGroup>
            </Col> */}
          </Row>      
          <Row>
            <Col md="6">
              <Button
                variant="contained"
                color="primary"
                onClick={updateUser}
                disabled={!isValidForm() || props.orgUserEditing}
              >
                Update User
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  const {
    orgUserEditing,
    editOrgUserMessage,
    editOrgUserError,
  } = state.orgUsers;

  return {
    orgUserEditing,
    editOrgUserMessage,
    editOrgUserError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateOrgUser: (userData) => {
      dispatch(putOrgUser(userData));
    },
    clearAllMessages: () => {
      dispatch(clearAllOrgUserMessages());
    },
    getOrgAccounts: (orgCode) => {
      dispatch(getOrgAccounts(orgCode));
    },
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(EditUserModal);